<div class="auction-content-body">
  <div class="card auction-content-main">
    <form [formGroup]="searchForm" class="auction-filter-wrapper d-flex align-items-end">
      <!-- VIN Number -->
      <div class="filter-field">
        <label class="filter-field__label" for="dt-inventory-search">VIN Number</label>
        <div class="filter-field__control">
          <ion-icon name="search-outline" class="filter-field__icon"></ion-icon>
          <input type="text" placeholder="Search by VIN" formControlName="vin_number" name="Vin_Number"
            autocomplete="off" class="form-control filter-field__input" id="dt-inventory-search"
            (input)="searchProductsFromList($event)" />
          <button *ngIf="searchForm.get('vin_number').value" type="button" class="filter-field__clear"
            (click)="clearField('vin_number', $event)">
            <ion-icon name="close-outline"></ion-icon>
          </button>
        </div>
      </div>

      <!-- Vehicle type -->
      <div class="filter-field">
        <label class="filter-field__label" for="dt-vehicle-type">Vehicle Type</label>
        <div class="filter-field__control">
          <ion-icon name="car-sport-outline" class="filter-field__icon"></ion-icon>
          <select formControlName="category" name="type" id="dt-vehicle-type"
            class="form-control filter-field__input filter-field__select" (change)="searchProductsFromList($event)">
            <option selected disabled value="">All vehicle types</option>
            <option value="2">Used</option>
            <option value="3">New</option>
          </select>
        </div>
      </div>

      <!-- Status -->
      <div class="filter-field">
        <label class="filter-field__label" for="dt-status">Status</label>
        <div class="filter-field__control">
          <ion-icon name="pricetag-outline" class="filter-field__icon"></ion-icon>
          <select formControlName="status" name="status" id="dt-status"
            class="form-control filter-field__input filter-field__select" (change)="searchProductsFromList($event)">
            <option selected disabled value="">All statuses</option>
            <option value="pending">Pending</option>
            <option value="reserve">Reserve</option>
            <option value="unreserve">Unreserve</option>
            <option value="sold">Sold</option>
          </select>
        </div>
      </div>

      <button *ngIf="isFilterMode" type="button"
        class="btn btn__main2 button_right_space curved flex-shrink-0 yellow ml-auto filter-clear-btn"
        (click)="resetFilter()">
        <ion-icon name="refresh-outline"></ion-icon>
        Clear filters
      </button>
    </form>

    <div *ngIf="noFilterMode" class="mx-3">
      <p *ngIf="!tableData.length" class="m-0">No data found</p>
      <table datatable [dtOptions]="dtOptions" id="purchase-request">
        <thead>
          <tr>
            <th *ngFor="let thead of theads">{{ thead }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>

    <div *ngIf="isFilterMode" class="mx-3">
      <p *ngIf="!tableData.length" class="m-0">No data found</p>
      <table datatable [dtOptions]="dtOptions2" id="purchase-request">
        <thead>
          <tr>
            <th *ngFor="let thead of theads">{{ thead }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  </div>
</div>